export enum AtiraLinkStylesBackgroundMode {
  COLOR = 'COLOR',
  IMAGE = 'IMAGE',
}
